export const patrycjaSawicka = {
    'meta': {
        'title': 'Lekarz rezydent psychiatrii Patrycja Sawicka-Czarniak • Centrum COLLIGO',
        'description': 'Jestem lekarzem w trakcie specjalizacji z psychiatrii. Ukończyłam studia uzyskując Nagrodę Rektora dla najlepszych absolwentów Wydziału Lekarskiego Uniwersytetu Medycznego w Łodzi.'
    },
    'url': {
        'address': '/torun/zespol/psychiatra-patrycja-sawicka-czarniak/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/patrycja-sawicka.webp',
            'width': 150,
            'height': 150,
            'alt': 'Lekarz rezydent psychiatrii Patrycja Sawicka-Czarniak'
        }
    }
}